import React from 'react'
import './ModalDeleteWaitList.scss'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import { ClientWaitlist } from '../../../../../types'
import { deleteWaitlistRecordById } from '../../../../../../../../../crud/clients_api/client_waitlist'
import { toast } from 'react-toastify';
import { X } from 'react-bootstrap-icons';
import { Spinner } from 'react-bootstrap';

interface ModalDeleteWaitLitsProps {
  show: boolean;
  onHide: () => void;
  waitlist: ClientWaitlist | null;
  onDeleted?: () => void;
  setWaitList?: (waitList: ClientWaitlist[]) => void;
  waitList?: ClientWaitlist[];
  getClientWaitlistByLocalId?: (localId: number) => Promise<any>;
  localId?: number;
}

const ModalDeleteWaitLits: React.FC<ModalDeleteWaitLitsProps> = ({ show, onHide, waitlist, onDeleted, setWaitList, waitList, getClientWaitlistByLocalId, localId }) => {
  const [loading, setLoading] = React.useState(false);
  const handleDelete = async () => {
    if (!waitlist) return;
    setLoading(true);
    try {
      await deleteWaitlistRecordById(waitlist.waitlist_id);
      toast.success('Eliminado correctamente');
      if (getClientWaitlistByLocalId && setWaitList) {
        const usedLocalId = localId ?? (JSON.parse(localStorage.getItem('user') || '{}')?.local_id ?? 0);
        const updated = await getClientWaitlistByLocalId(usedLocalId);
        setWaitList(updated);
      } else if (setWaitList && waitList) {
        setWaitList(waitList.filter(w => w.waitlist_id !== waitlist.waitlist_id));
      }
      if (onDeleted) onDeleted();
      onHide();
    } catch (e: any) {
      let msg = 'Error al eliminar.';
      if (e && e.message) msg = e.message;
      else if (typeof e === 'object') msg = JSON.stringify(e);
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Modal show={show} onHide={onHide} centered className='modal-delete-waitlist'>
      <Modal.Header>
        <div className="form-modal-title-container">
          <Modal.Title className="form-modal-title">
            Eliminar de la Lista de Espera
          </Modal.Title>
        </div>
        <Button variant="none" className="modal-close-button" onClick={onHide} disabled={loading}>
          <X size={24} />
        </Button>
      </Modal.Header>
      <Modal.Body>
        ¿Estás seguro de eliminar esta lista de espera?
      </Modal.Body>
      <Modal.Footer>
        <div className="form-modal-footer-custom">
          <Button variant="none" className='form-button-cancel' onClick={onHide} disabled={loading}>
            Cancelar
          </Button>
          <Button variant="none" className='form-button-create' onClick={handleDelete} disabled={loading}>
            {loading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  style={{ marginRight: '0.5rem' }}
                />
                Eliminando...
              </>
            ) : (
              'Confirmar'
            )}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalDeleteWaitLits;